import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Container from 'olive-react-myoneui/lib/Container';
import { closeCircleIcon } from "../../components/constants/icons";
import { verifyMailProcess } from '../../api/afterLogin/notification';

const TopNotificationBar = ({ className }) => {
  const [visible, setVisible] = useState(true); 
  const [isAtTop, setIsAtTop] = useState(window.scrollY === 0);
  const [verify, setVerify]   = useState(true);
  const emailVerified = useSelector((state) => state.user.user.logged_in_user.user.us_email_verified);
  
  const barRef = useRef(null);

  const messagenotificationBarShow = localStorage?.messagenotification ? new Date().getTime() > parseInt(localStorage?.messagenotification) + 3600000 : true;

  const verifyMail = async () => {
    const host     = window.location.hostname
    const response = await verifyMailProcess(host);
    if (response?.data === 'success') {
      setVerify(false);
    }
  }

  const handleClose = (e) => {
    e.preventDefault();
    localStorage.setItem('messagenotification', new Date().getTime());
    setVisible(false);
    setVerify(false);
  };

  useEffect(() => {
    const updateBodyMargin = () => {
      if (isAtTop) {
        const bars = document.querySelectorAll('.myk__stu-top_notification-bar');
        const totalHeight = Array.from(bars).reduce((sum, bar) => sum + bar.offsetHeight, 0);
        document.body.style.marginTop = `${totalHeight}px`;
      } else {
        document.body.style.marginTop = '0px';
      }
    };

    updateBodyMargin();
    window.addEventListener('resize', updateBodyMargin);

    return () => {
      document.body.style.marginTop = '0px'; // Reset on unmount
      window.removeEventListener('resize', updateBodyMargin);
    };
  }, [isAtTop, visible]);

  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY === 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
    {messagenotificationBarShow && emailVerified == 0 ?
    <div ref={barRef} className={`${className || ''} myk__stu-top_notification-bar`} aria-live="polite">
      <Container>
        <div className="myk__stu-top_bar-wrapper">
          <div className="myk__stu-top_bar-inner">
            {verify ?
            <p>Oops! have not verified your email yet. Please, verify your email as soon as possible. <a href="#" onClick={verifyMail}><strong>Verify Email</strong></a></p>
            : <p>The verification email has been sent. Check your inbox and verify.</p>
            }
          </div>
        </div>
        <span className="close" onClick={(e) => handleClose(e)} rule="button" aria-label="Close notification">
          {closeCircleIcon}
        </span>
      </Container>
    </div> : ''
    }
    </>
  );
}

export default TopNotificationBar;
